import { Box, Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { keyframes } from '@emotion/react';
import { useEffect, useRef } from 'react';
import CpRegistraions from '../../components/modals/cpRegistrations';
import { Card, Dialog } from "@mui/material";
import { FormControl, FormLabel, FormControlLabel, Select, Switch, Checkbox, InputLabel, MenuItem } from "@mui/material";
import React, { useState } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, Field, FormikProvider, ErrorMessage } from "formik";
import CloseIcon from '@mui/icons-material/Close';
import FormField from '../../components/form/formField';
import userServices from "../../services/userServices";
import { useSnackbar } from "notistack";
import { COMMON, ORGNIZATION_TYPES, PLATFORM_OPTIONS, REALX_REFERENCES_LIST, STATES } from "../../utils/constants";
import ApartmentIcon from '@mui/icons-material/Apartment';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import LanguageIcon from '@mui/icons-material/Language';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SellIcon from '@mui/icons-material/Sell';
import FlagIcon from '@mui/icons-material/Flag';

const inviteSchema = Yup.object().shape({
  fname: Yup.string().required("First Name is required."),
  lname: Yup.string().required("Last name is required."),
  email: Yup.string().email("Please enter a valid email.").required("Email is required."),
  mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits').required("Mobile is required."),
  city: Yup.string().required("City is required."),
  area: Yup.string().required("Area/Location is required."),
  state: Yup.string().required("State is required."),
  orgname: Yup.string().required("Orgnization name is required."),
  orgtype: Yup.string().required("Orgnization type is required."),
  reference: Yup.string().required("Reference is required."),
  directInvestors: Yup.string().required("Number of direct investor is required."),
  indirectInvestors: Yup.string().required("Number of associate channel partners is required."),
  noofassociatedcps: Yup.string().required("Total number investor is required."),
  doyouknowfraxownership: '',
  haveyouinvestedinfrax: '',
  gotclientsforfrax: '',
  platformsused: '',
});


// Define keyframes for animations
const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export default function PartnerWithRealX(){
  const contactRef = useRef(null);

    return(
        <>
            <HeroSection onScrollToContact={()=>contactRef.current?.scrollIntoView({behavior:'smooth'})}/>
            <Benefits />
            <PartnerTypes/>
            <TargetAudience />
            <HowItWorks/>
            <ContactSection ref={contactRef} />
        </>
    )
}


const HeroSection=({onScrollToContact})=>{
    return(
        <Box
      sx={{
        pt: { xs: 14, md: 20 },
        pb: { xs: 4, md: 16 },
        px: { xs: 3, md: 6, lg: 8 },
        background: 'linear-gradient(to bottom right, #eff6ff, #ffffff)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            animation: `${slideUp} 0.6s ease-out`,
          }}
        >
            <Stack rowGap={{ xl: 4, lg: 4, md: 3, xs: 2 }}>

              <Typography sx={{ fontSize: { xl: 65, lg: 45, md: 40, xs: 36 }, fontWeight: 600, fontFamily: "Teko", lineHeight: { md: 0.9, xs: 1 } }}>
                Partner with RealX <br />
                <Box sx={{ color: "primary.error" }}>Unlock New Earning Opportunities</Box>
              </Typography>
              {/* <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '3.75rem' },
              fontWeight: 700,
              color: 'black',
              mb: 3,
              fontFamily: 'Teko, sans-serif',
              lineHeight: 1.2,
            }}
          >
            Partner with RealX – Unlock New Earning Opportunities
          </Typography> */}

              <Typography
                variant="landingSubText"
                sx={{
                  // mb: 4,
                  animation: `${fadeIn} 0.8s ease-out`,
                  animationDelay: '0.2s',
                  animationFillMode: 'forwards',
                  fontFamily: 'Poppins, sans-serif',
                  lineHeight: 1.7,
                }}
              >
                Join India's leading real estate investment platform and offer your clients access to
                premium fractional ownership opportunities while earning attractive commissions
              </Typography>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                sx={{
                  animation: `${slideUp} 0.8s ease-out`,
                  animationDelay: '0.4s',
                  animationFillMode: 'forwards',
                  fontFamily: 'Poppins, sans-serif',
                  // mt: 4
                }}
              >
                <Button
                  href="#contact"
                  variant="contained"
                  color="error"
                  endIcon={<ChevronRightIcon />}
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontWeight: 500,
                    boxShadow: 2,
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: 'error.dark',
                    },
                    padding:'12px 24px !important'
                  }}
                  onClick={onScrollToContact}

                >
                  Sign up as a channel partner
                </Button>

                {/* <Button
                  href="#benefits"
                  variant="outlined"
                  color="error"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontWeight: 500,
                    borderWidth: 1.5,
                    '&:hover': {
                      backgroundColor: 'rgba(255, 0, 0, 0.05)',
                    },
                    padding:'12px 24px !important'
                  }}
                >
                  Learn More
                </Button> */}
              </Stack>
            </Stack>
        </Box>
      </Container>

      {/* Decorative Circles */}
      <Box
        sx={{
          position: 'absolute',
          top: -80,
          right: -80,
          width: 256,
          height: 256,
          borderRadius: '50%',
          backgroundColor: 'rgba(239, 68, 68, 0.2)',
          animation: `${fadeIn} 1s ease-out`,
          animationDelay: '0.6s',
          animationFillMode: 'forwards',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 40,
          width: 128,
          height: 128,
          borderRadius: '50%',
          backgroundColor: 'rgba(252, 165, 165, 0.5)',
          animation: `${fadeIn} 1s ease-out`,
          animationDelay: '0.8s',
          animationFillMode: 'forwards',
          display:{xs:'none',md:'block'}
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          right: '25%',
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: 'rgba(248, 113, 113, 0.2)',
          animation: `${fadeIn} 1s ease-out`,
          animationDelay: '1s',
          animationFillMode: 'forwards',
        }}
      />
    </Box>
    )

}


const Benefits = ()=>{
    //  const sectionRef = useRef(null);
     const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

  /* ---- simple intersection-observer hook ---- */
//   useEffect(() => {
//     const el = sectionRef.current;
//     if (!el) return;
//     const io = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) el.style.animation = `${fadeInUp} 0.7s forwards`;
//       },
//       { threshold: 0.15 }
//     );
//     io.observe(el);
//     return () => io.disconnect();
//   }, []);

    const benefits = [
    {
    //   icon: <CreditCard className="h-6 w-6" />,
      title: "Attractive Commission Structure",
      description: "Earn industry-leading commissions on every investment closed through your referral network"
    },
    {
    //   icon: <Award className="h-6 w-6" />,
      title: "High-Quality Investment Products",
      description: "Offer your clients access to Grade-A commercial real estate assets through a transparent platform"
    },
    {
    //   icon: <Briefcase className="h-6 w-6" />,
      title: "Marketing & Sales Support",
      description: "From brochures to webinars to onboarding guides—we provide everything you need to succeed"
    },
    {
    //   icon: <BarChart3 className="h-6 w-6" />,
      title: "Real-Time Dashboard Access",
      description: "Track your leads, conversions, and commissions with our dedicated Partner dashboard"
    }
  ];


    return(
         <Box
    //   id="benefits"
      sx={{
        py: { xs: 5, md: 10 },
        px: { xs: 3, md: 6 },
        backgroundColor: 'grey.50',
      }}
    >
      <Container>
        <Box
        //   ref={sectionRef}
          sx={{ 
            textAlign: 'center',
            maxWidth: 640,
            mx: 'auto',
            mb: 8,
            // opacity: 0,           // start hidden; animation sets opacity → 1
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.875rem', md: '2.25rem' },
              fontWeight: 700,
              fontFamily: 'Teko, sans-serif',
              mb: 1,
              color: 'text.primary',
            }}
          >
            Why Partner with RealX?
          </Typography>

          <Typography
            variant="landingSubText"
          >
            Discover the advantages of joining our growing network of trusted advisors and
            partners.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {benefits.map((benefit, i) => (
            <Grid item xs={12} md={6} lg={3} key={i}>
              <BenefitCard
                icon={benefit.icon}
                title={benefit.title}
                description={benefit.description}
                delay={0.2 * i}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
    )

}

function BenefitCard({ icon: Icon, title, description, delay = 0 }) {
  
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        height: '100%',
         transition: 'all 0.3s ease',
        boxShadow: 3,
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      
      }}
    >
      <Stack spacing={2} alignItems="flex-start">
        {/* Expecting the icon prop to be a React component */}
        {Icon && <Icon style={{ fontSize: 32, color: '#ef4444' }} />}

        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title} 
        </Typography>

        <Typography variant="body3">
          {description}
        </Typography>
      </Stack>
    </Paper>
  );
}



const AudienceCard = ({ icon, title, description }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.100',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 4,
        },
        bgcolor: 'white',
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={2}>
        {/* Icon Wrapper */}
        <Box
          sx={{
            p: 1,
            bgcolor: 'error.lighter', // red-50 equivalent
            color: 'error.main',       // red-600 equivalent
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 40,
          }}
        >
          {icon}
        </Box>

        {/* Title and Description */}
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body3"
            sx={{
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

const TargetAudience =()=>{

     const audiences = [
    {
      icon: < PeopleAltIcon/>,
      title: "Retail Investors",
      description: "Individuals seeking passive income and long-term growth through real estate investments"
    },
    {
      icon: <GroupsIcon />,
      title: "HNWIs & UHNWIs",
      description: "High-net-worth individuals looking to diversify their real estate investment portfolio"
    },
    {
      icon: <FlagIcon />,
      title: "NRIs",
      description: "Non-resident Indians interested in gaining exposure to the Indian real estate market"
    },
    {
      icon: <ApartmentIcon/>,
      title: "Corporates",
      description: "Companies aiming to park surplus funds in tangible investments with stable returns"
    }
  ];

    return(
         <Box
      sx={{
        py: { xs: 5, md: 14 },
        px: { xs: 3, md: 6 },
        bgcolor: 'grey.50',
      }}
    >
      <Container>
        {/* Header */}
        <Box
          sx={{
            textAlign: 'center',
            maxWidth: '640px',
            mx: 'auto',
            mb: 8,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.875rem', md: '2.25rem' },
              fontWeight: 700,
              mb: 2,
              fontFamily: 'Teko, sans-serif',
              color: 'text.primary',
            }}
          >
            Who Will You Be Helping?
          </Typography>

          <Typography
            variant="landingSubText"
            sx={{
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Connect your clients with premium real estate investment opportunities
          </Typography>
        </Box>

        {/* Cards */}
        <Box sx={{ maxWidth: '1024px', mx: 'auto' }}>
          <Grid container spacing={3}>
            {audiences.map((audience, index) => (
              <Grid item xs={12} md={6} key={index}>
                <AudienceCard
                  icon={audience.icon}
                  title={audience.title}  
                  description={audience.description}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
    )
}





const PartnerType = ({ icon, title }) => {
  return (
    <Paper
  elevation={1}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 2,
    bgcolor: 'white',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'grey.100',
    transition: 'all 0.3s ease',
    minHeight: 100,// ⬅️ Set a consistent minimum height
    '&:hover': {
      boxShadow: 4,
    },
  }}
>
  {/* Icon Box */}
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 1.5,
      bgcolor: 'error.lighter', // red-50
      color: 'error.main',       // red-600
      borderRadius: 2,
    }}
  >
    {icon}
  </Box>

  {/* Title */}
  <Typography
    variant="body1"
    sx={{
      fontWeight: 500,
      color: 'text.primary',
      fontFamily: 'Poppins, sans-serif',
    }}
  >
    {title}
  </Typography>
</Paper>

  );
};




const PartnerTypes=()=>{
    const partnerTypes = [
    {
      icon: <ApartmentIcon  />,
      title: "Real Estate Brokers and Agents"
    },
    {
      icon: <CurrencyRupeeIcon />,
      title: "Wealth Managers & Financial Advisors"
    },
    {
      icon: <CastForEducationIcon />,
      title: "Investment Consultants"
    },
    {
      icon: <LanguageIcon />,
      title: "Online Financial Platforms"
    },
    {
      icon: <GroupsIcon/>,
      title: "Boutique Advisory Firms"
    }
  ];
    return(
         <Box
      id="partners"
      sx={{
        py: { xs: 5, md: 14 },
        px: { xs: 3, md: 6 },
        bgcolor: 'white',
      }}
    >
      <Container>
        {/* Header */}
        <Box
          sx={{
            textAlign: 'center',
            maxWidth: '640px',
            mx: 'auto',
            mb: 8,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.875rem', md: '2.25rem' },
              fontWeight: 700,
              mb: 2,
              color: 'text.primary',
              fontFamily: 'Teko, sans-serif',
            }}
          >
            Who Can Become a Channel Partner?
          </Typography>

          <Typography
            variant="landingSubText"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              mb: 4,
            }}
          >
            If you have a trusted network of investors or property buyers, you can unlock a powerful new revenue stream.
          </Typography>
        </Box>

        {/* Grid of Partner Types */}
        <Box sx={{ maxWidth: '1024px', mx: 'auto' }}>
          <Grid container spacing={2}>
            {partnerTypes.map((type, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <PartnerType
                  icon={type.icon}
                  title={type.title}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
    )
}



const Step = ({ icon, title, description, number, delay = 0, stepRef }) => {
//   const theme = useTheme();

  return (
    <Box
    //   ref={stepRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        opacity: 0, // animate later
        animationDelay: `${delay}s`,
        transition: 'opacity 0.6s ease-out',
      }}
    >
      {/* Step Circle with Icon */}
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'error.main',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
            // boxShadow: theme.shadows[3],
          }}
        >
          {icon}
        </Box>

        {/* Connecting Line (only if not last step) */}
        {number < 4 && (
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              position: 'absolute',
              top: '40px',
              right: '-100%',
              width: '100%',
              height: '2px',
              backgroundColor: 'error.lighter',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: 'error.light',
              }}
            />
          </Box>
        )}
      </Box>

      {/* Step Title */}
      <Typography
        variant="h6"
        sx={{
          fontSize: '1.5rem',
          fontWeight: 600,
          color: 'text.primary',
          mb: 1.5,
          fontFamily: 'Teko, sans-serif',
        }}
      >
        {title}
      </Typography>

      {/* Step Description */}
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          maxWidth: 280,
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};
const HowItWorks=()=>{

    const Step = ({ icon, title, description, number, delay = 0, stepRef }) => {
//   const theme = useTheme();

  return (
    <Box
    //   ref={stepRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        // opacity: 0, // animate later
        animationDelay: `${delay}s`,
        transition: 'opacity 0.6s ease-out',
      }}
    >
      {/* Step Circle with Icon */}
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'error.main',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
            // boxShadow: theme.shadows[3],
          }}
        >
          {icon}
        </Box>

        {/* Connecting Line (only if not last step) */}
        {number < 4 && (
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              position: 'absolute',
              top: '40px',
              right: '-100%',
              width: '100%',
              height: '2px',
              backgroundColor: 'error.lighter',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: 'error.light',
              }}
            />
          </Box>
        )}
      </Box>

      {/* Step Title */}
      <Typography
        variant="h6"
        sx={{
          fontSize: '1.5rem',
          fontWeight: 600,
          color: 'text.primary',
          mb: 1.5,
        //   fontFamily: 'Teko, sans-serif',
        }}
      >
        {title}
      </Typography>

      {/* Step Description */}
      <Typography
        variant="body3"
        sx={{
          maxWidth: 280,
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

     const steps = [
    {
      number: 1,
      title: "Register",
      description: "Complete a simple registration process as a Channel Partner",
      icon: <PersonAddAlt1Icon />
    },
    {
      number: 2,
      title: "Onboard",
      description: "Introduce your clients to the RealX platform",
      icon: <PeopleAltIcon />
    },
    {
      number: 3,
      title: "Assist",
      description: "Help clients explore and invest in real estate products",
      icon: <CurrencyRupeeIcon />
    },
    {
      number: 4,
      title: "Earn",
      description: "Receive commissions on every successful transaction",
      icon: <SellIcon/>
    }
  ];
    return(
         <Box
    //   id="process"
      sx={{
        py: { xs: 5, md: 14

        },
        px: { xs: 3, md: 6 },
        background: 'linear-gradient(to bottom, #f9fafb, #ffffff)', // from-gray-50 to-white
      }}
    >
      <Container>
        {/* Header */}
        <Box
        //   ref={sectionRef}
          sx={{
            textAlign: 'center',
            maxWidth: 640,
            mx: 'auto',
            mb: 10,
            // opacity: 0, // Optional: can animate using framer-motion or IntersectionObserver
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.875rem', md: '2.25rem' },
              fontWeight: 700,
              mb: 2,
              color: 'text.primary',
              fontFamily: 'Teko, sans-serif',
            }}
          >
            How It Works
          </Typography>

          <Typography
            variant="landingSubText"
            sx={{
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Our simple four-step process to become a successful RealX Channel Partner
          </Typography>
        </Box>

        {/* Step Cards */}
        <Box sx={{ maxWidth: '1280px', mx: 'auto', px: 2 }}>
          <Grid container spacing={4}>
            {steps.map((step, index) => (
              <Grid item xs={12} md={3} key={step.number}>
                <Step
                  number={step.number}
                  title={step.title}
                  description={step.description}
                  icon={step.icon}
                  delay={0.2 * index} // Optional: for animation if you're using delay logic
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
    )
}


const CpRegistrationForm =()=>{
    window.heap.track('Start Investing', {
        buttonName: 'Start Investing',
        category: 'Home page event',
      });
    
      const { enqueueSnackbar } = useSnackbar();
    
      const formik = useFormik({
        initialValues: {
          fname: "",
          lname: "",
          email: "",
          mobile: "",
          city: "",
          area: "",
          state: "Maharashtra",
          orgname: "",
          orgtype: "",
          directInvestors: "",
          indirectInvestors: "",
          noofassociatedcps: "",
          doyouknowfraxownership: false,
          haveyouinvestedinfrax: false,
          gotclientsforfrax: false,
          platformsused: "",
          reference: "",
    
        },
        validationSchema: inviteSchema,
        onSubmit: (cpDetails) => {
          const cpRegistrationPayload = {
            name: `${cpDetails.fname} ${cpDetails.lname}`,
            mobileNo: cpDetails.mobile,
            email: cpDetails.email,
            location: { city: cpDetails.city, area: cpDetails.area, state: cpDetails.state },
            organisation: { name: cpDetails.orgname, type: cpDetails.orgtype },
            miscDetails: {
              directInvestors: cpDetails.directInvestors,
              indirectInvestors: cpDetails.indirectInvestors,
              noofassociatedcps: cpDetails.noofassociatedcps,
              doyouknowfraxownership: cpDetails.doyouknowfraxownership || false,
              haveyouinvestedinfrax: cpDetails.haveyouinvestedinfrax || false,
              gotclientsforfrax: cpDetails.gotclientsforfrax || false,
              platformsused: selectedInterests,
            },
            reference: cpDetails.reference,
          };
    
          saveDetails(cpRegistrationPayload);
          resetForm();
        },
      });
    
      /**
       * Signup for Channel Partner
       * @param {*} data Channel partner data
       */
      const saveDetails = async (data) => {
        const res = await userServices.addCpDetails(data);
        if (res && res.success) {
          enqueueSnackbar(COMMON.CHANNEL_PARTNER_TOAST.SUCCESS, { variant: "success" });
        //   handleClose();
        }
        else {
          enqueueSnackbar(COMMON.CHANNEL_PARTNER_TOAST.ERROR, { variant: "error" })
        }
      }
    
      const { errors, touched, handleSubmit, getFieldProps, setFieldValue, resetForm } = formik;
    
      const onClose = () => {
        resetForm();
        // handleClose();
      }
    
      const [selectedInterests, setSelectedInterests] = useState([]);
    
      const handleInterestsChange = (event) => {
        setSelectedInterests(event.target.value);
      };
    
      return (
       
          <Card>
            <Box sx={{
              position: "absolute",
              right: 0,
              padding: 2.5,
              color: { md: "#000", xs: "text.disabled" }
            }}>
              {/* <CloseIcon onClick={onClose} sx={{ width: 24, height: 24, cursor: "pointer" }} /> */}
            </Box>
            <Grid container width={"100%"}>
    
              <Grid container>
                <Grid item md={12} xs={12}>
                  <Box sx={{ padding: '22px 35px 0px 35px', textAlign: 'center' }}>
                    <Stack>
                      <Typography variant="h4" gutterBottom>
                        Signup As Channel Partner
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
    
                <Grid item md={12} xs={12} >
                  <Box sx={{ padding: '15px 35px 35px 35px' }}>
                    <FormikProvider value={formik}>
                      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"First Name*"}
                              inputProps={{
                                ...getFieldProps("fname"),
                                error: Boolean(touched.fname && errors.fname),
                                helperText: touched.fname && errors.fname,
                                  onInput: (e) => {
                                  // Only allow letters (a-z, A-Z) and spaces
                                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                }
                              }}
                            />
                          </Grid>
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Last Name*"}
                              inputProps={{
                                ...getFieldProps("lname"),
                                error: Boolean(touched.lname && errors.lname),
                                helperText: touched.lname && errors.lname,
                                 onInput: (e) => {
                                  // Only allow letters (a-z, A-Z) and spaces
                                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                }
                              }}
                            />
                          </Grid>
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Email ID*"}
                              inputProps={{
                                ...getFieldProps("email"),
                                error: Boolean(touched.email && errors.email),
                                helperText: touched.email && errors.email
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Mobile Number*"}
                              inputProps={{
                                ...getFieldProps("mobile"),
                                error: Boolean(touched.mobile && errors.mobile),
                                helperText: touched.mobile && errors.mobile,
                                onInput: (e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                }
                              }}
                            />
                          </Grid>
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"City*"}
                              inputProps={{
                                ...getFieldProps("city"),
                                error: Boolean(touched.city && errors.city),
                                helperText: touched.city && errors.city,
                                 onInput: (e) => {
                                  // Only allow letters (a-z, A-Z) and spaces
                                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Area/Location*"}
                              inputProps={{
                                ...getFieldProps("area"),
                                error: Boolean(touched.area && errors.area),
                                helperText: touched.area && errors.area,
                                 onInput: (e) => {
                                  // Only allow letters (a-z, A-Z) and spaces
                                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormControl fullWidth>
                              <FormLabel sx={{ fontSize: '0.875rem !important; color: #817b7b' }}>States*</FormLabel> {/* Use the same label */}
                              <Select sx={{ marginTop: '8px' }}
                                {...getFieldProps("state")}
                                error={Boolean(touched.state && errors.state)}
                              >
                                {STATES.map(option => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Orgnization name, if any *"}
                              inputProps={{
                                ...getFieldProps("orgname"),
                                error: Boolean(touched.orgname && errors.orgname),
                                helperText: touched.orgname && errors.orgname,
                                 onInput: (e) => {
                                  // Only allow letters (a-z, A-Z) and spaces
                                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormControl fullWidth>
                              <FormLabel sx={{ fontSize: '0.875rem !important; color: #817b7b' }}>Orgnization Type *</FormLabel>
                              <Select sx={{ marginTop: '8px' }}
                                {...getFieldProps("orgtype")}
                                error={Boolean(touched.orgtype && errors.orgtype)}
                              >
                                {ORGNIZATION_TYPES.map(option => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              <ErrorMessage name="orgtype" component="div" className="error-message" /> {/* Display the error message */}
    
                            </FormControl>
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Number of Direct Investors *"}
                              inputProps={{
                                ...getFieldProps("directInvestors"),
                                error: Boolean(touched.directInvestors && errors.directInvestors),
                                helperText: touched.directInvestors && errors.directInvestors,
                                onInput: (e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Number of associated Channel Partners *"}
                              inputProps={{
                                ...getFieldProps("noofassociatedcps"),
                                error: Boolean(touched.noofassociatedcps && errors.noofassociatedcps),
                                helperText: touched.noofassociatedcps && errors.noofassociatedcps,
                                onInput: (e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormField
                              label={"Total (Direct + Indirect) Investors *"}
                              inputProps={{
                                ...getFieldProps("indirectInvestors"),
                                error: Boolean(touched.indirectInvestors && errors.indirectInvestors),
                                helperText: touched.indirectInvestors && errors.indirectInvestors,
                                onInput: (e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                }
                              }}
                            />
                          </Grid>
    
    
                          <Grid item md={12} sm={12} xs={12}>
                            <Field name="doyouknowfraxownership">
                              {({ field }) => (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...field}
                                      checked={field.value}
                                      onChange={field.onChange}
                                    />
                                  }
                                  label="Do you know about fractional ownership?"
                                  labelPlacement="end"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    marginRight: '20px',
                                  }}
                                />
                              )}
                            </Field>
                          </Grid>
                          <Grid item md={12} sm={12} xs={12}>
                            {/* Toggle button */}
                            <Field name="haveyouinvestedinfrax">
                              {({ field }) => (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...field}
                                      checked={field.value}
                                      onChange={field.onChange}
                                    />
                                  }
                                  label="Have you ever invested in fractional real estate?"
                                  labelPlacement="end"
                                />
                              )}
                            </Field>
                          </Grid>
                          <Grid item md={12} sm={12} xs={12}>
    
                            {/* Toggle button */}
                            <Field name="gotclientsforfrax">
                              {({ field }) => (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...field}
                                      checked={field.value}
                                      onChange={field.onChange}
                                    />
                                  }
                                  label="Have you gotten your clients to invest in fractional real estate?"
                                  labelPlacement="end"
                                />
                              )}
                            </Field>
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormControl fullWidth sx={{ marginTop: '8px' }}>
                              <InputLabel
                                sx={{
                                  fontSize: '1.2rem !important',
                                  color: '#817b7b',
                                }}
                                shrink={true} // Add this prop to prevent the label from floating
                              >
                                If Yes, then select platform(s) you have used
                              </InputLabel>
                              <Select
                                sx={{ marginTop: '18px' }}
                                multiple
                                value={selectedInterests}
                                onChange={handleInterestsChange}
                                name="platformsused"
                                renderValue={(selected) => selected.join(', ')}
                              >
                                {PLATFORM_OPTIONS.map((platform) => (
                                  <MenuItem key={platform.value} value={platform.value}>
                                    <Checkbox checked={selectedInterests.indexOf(platform.value) > -1} />
                                    {platform.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
    
                          <Grid item md={6} sm={6} xs={12}>
                            <FormControl fullWidth>
                              <FormLabel sx={{ fontSize: '0.875rem !important; color: #817b7b' }}>RealX Reference</FormLabel>
                              <Select sx={{ marginTop: '8px' }}
                                {...getFieldProps("reference")}
                                error={Boolean(touched.reference && errors.reference)}
                              >
                                {REALX_REFERENCES_LIST.map(option => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              <ErrorMessage name="reference" component="div" className="error-message" /> {/* Display the error message */}
                            </FormControl>
                          </Grid>
    
                          {/* ...remaining form fields */}
                        </Grid>
                        <Stack pt={4} direction="row" sx={{ alignItems: 'center', justifyContent: 'center' }} spacing={2}>
                          <Button type="submit" variant="contained" sx={{padding:'12px 24px !important'}}>
                            Submit
                          </Button>
                          <Button type="reset" variant="outlined" sx={{padding:'12px 24px !important'}}>Reset</Button>
                        </Stack>
                      </Form>
                    </FormikProvider>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        )
}

const ContactSection=({ref})=>{
    return(

        <Box id="contact" sx={{ py: {xs:5,md:14}, px: 3, bgcolor: 'white' }} ref={ref}>
        <Container maxWidth="lg">
          <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Grid container>

              {/* Left Side - 40% */}
              <Grid item xs={12} md={3} sx={{ bgcolor: 'error.main', color: 'white', p: 4 }}>
                <Typography variant="h4"  mb={3}>
                  Start Earning Today
                </Typography>
                <Typography mb={4}>
                  Join our growing network of trusted advisors and partners. Whether you're an
                  independent advisor or a large distribution firm, RealX offers you the
                  opportunity to scale your business with the future of real estate investing.
                </Typography>
                <Box display="flex" alignItems="center" mb={2}>
                 <a href="mailto:hi@realx.in" style={{textDecoration:"none"}}>
                  <Typography variant="h4" sx={{fontFamily:"Proxima Nova Rg",color:"#FFF"}}>hi@realx.in</Typography>
                 </a>
                </Box>
                <Box display="flex" alignItems="center">
                  {/* <Typography>+91 XXX XXX XXXX</Typography> */}
                </Box>
              </Grid>

              {/* Right Side - 60% */}
              <Grid item xs={12} md={9} sx={{ p: 1}}>
                <CpRegistrationForm />
              </Grid>

            </Grid>
          </Paper>
        </Container>
        </Box>
    )
}